import React from 'react';
import EditImpactedTables from '../EditImpactedTables';

export default function EditPalmImpactDetail(props) {
    return <div>
        <EditImpactedTables impactType="PALM" arrayProperty={`palmImpactedTables`} impactSuggestion={props.impactSuggestion}
            dependencyProperty={`palmApplicationDependencies`} />,
</div>
}